export default 'event:team-created';

export type TeamCreatedEventParameters = {
    teamId: string,
};
